// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-m_fn","advertDetailContactGroup__header":"c-m_fo","advertDetailContactGroup__value":"c-m_fp"};